import React from 'react';
import { Alert, Button } from "antd";
import { Select } from "../../../components/shared/OptionWidthControl";
import { useVehicleVariants } from '../viewmodels/useVehicleVariants';

export function VehicleVariantSelect({ familyId, savedId, savedName, managed, revision, ...props }) {
  return <VariantControl key={JSON.stringify([familyId, revision])} familyId={familyId} savedId={savedId} savedName={savedName} managed={managed} {...props} />;
}
function VariantControl({ familyId, savedId, savedName, managed, ...props }) {
  const vm = useVehicleVariants(familyId, { savedId, savedName, managed });
  return <>
    <Select {...props} aria-label={props['aria-label'] || 'Vehicle variant'} style={{ width: '100%' }} allowClear showSearch filterOption={false} onSearch={vm.setSearch} options={vm.options} loading={vm.loading}
      disabled={!familyId || props.disabled} notFoundContent={vm.loading ? 'Loading variants…' : 'No matching variants'}
      popupRender={menu => <>{menu}{vm.hasMore && <Button block disabled={vm.loading} onMouseDown={event => event.preventDefault()} onClick={vm.loadMore}>Load more variants</Button>}</>} />
    {vm.error && <Alert type="error" message={vm.error} action={<Button onClick={vm.reload}>Retry variants</Button>} />}
  </>;
}
